import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProducts = (products) => ({
  type: actionTypes.SET_PRODUCTS,
  payload: products
})
